(() => {
  const mountProductAsSeenOn = () => {
    const slot = document.querySelector('[data-tis-product-as-seen-slot]');
    const sectionHost = document.querySelector('.tis-product-as-seen-section');
    const presentation = sectionHost?.querySelector('.tis-product-as-seen');
    if (!slot || !sectionHost || !presentation || slot.contains(sectionHost)) return;

    slot.append(sectionHost);
    slot.setAttribute('data-tis-product-as-seen-mounted', '');
  };

  mountProductAsSeenOn();
  document.addEventListener('shopify:section:load', mountProductAsSeenOn);

  document.querySelectorAll('[data-tis-size-guide]').forEach((root) => {
    const dialog = root.querySelector('[data-tis-size-guide-dialog]');
    const trigger = root.querySelector('[data-tis-size-guide-open]');
    const closeButton = root.querySelector('[data-tis-size-guide-close]');
    const unitButtons = root.querySelectorAll('[data-tis-size-unit]');
    let pageScrollPosition = 0;
    let restoreFocusAfterClose = false;
    let openingFrame = 0;

    const restorePagePosition = () => window.scrollTo({ top: pageScrollPosition, left: 0, behavior: 'auto' });
    const lockPagePosition = () => {
      document.documentElement.style.setProperty('--tis-size-guide-scroll-offset', `-${pageScrollPosition}px`);
      document.documentElement.classList.add('tis-size-guide-open');
    };

    const unlockPagePosition = () => {
      if (!document.documentElement.classList.contains('tis-size-guide-open')) return;
      document.documentElement.classList.remove('tis-size-guide-open');
      document.documentElement.style.removeProperty('--tis-size-guide-scroll-offset');
      restorePagePosition();
    };

    const finishClose = () => {
      unlockPagePosition();
      if (!restoreFocusAfterClose) return;
      restoreFocusAfterClose = false;
      trigger?.focus({ preventScroll: true });
    };

    const closeDialog = () => {
      window.cancelAnimationFrame(openingFrame);
      if (dialog?.open) {
        dialog.close();
      } else {
        finishClose();
      }
    };

    trigger?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (dialog?.open) return;

      pageScrollPosition = window.scrollY;
      restoreFocusAfterClose = true;

      // Native select menus are rendered outside the document. Blurring every
      // product select and waiting one frame lets the browser dismiss that UI
      // before the modal enters the top layer on desktop, iOS and Android.
      root.closest('section')?.querySelectorAll('select').forEach((select) => select.blur());
      document.activeElement?.blur();

      openingFrame = window.requestAnimationFrame(() => {
        lockPagePosition();
        if (!dialog?.open) dialog?.showModal();
        window.requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
      });
    });

    closeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      closeDialog();
    });

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.tisSizeUnit;
        unitButtons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        root.querySelectorAll('[data-tis-size-value]').forEach((cell) => {
          const inchValue = Number.parseFloat(cell.dataset.inch);
          const centimetreValue = Number.parseFloat(cell.dataset.cm);
          if (unit === 'cm' && Number.isFinite(centimetreValue)) {
            cell.textContent = cell.dataset.cm;
          } else if (unit === 'cm' && Number.isFinite(inchValue)) {
            cell.textContent = Math.round(inchValue * 2.54 * 10) / 10;
          } else {
            cell.textContent = cell.dataset.inch || '';
          }
        });
      });
    });

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog?.addEventListener('close', () => {
      finishClose();
    });
    dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
  });

  document.querySelectorAll('.product__description img, .product__description picture, .product__description figure').forEach((media) => {
    media.remove();
  });

  document.querySelectorAll('.product__description p').forEach((paragraph) => {
    if (!paragraph.textContent.trim() && paragraph.children.length === 0) paragraph.remove();
  });

  document.querySelectorAll('.tis-sibling-swatches--product').forEach((swatches) => {
    const links = [...swatches.querySelectorAll('.tis-sibling-swatches__link')];
    const expandButton = swatches.querySelector('[data-tis-swatches-expand]');
    links.forEach((link) => { link.hidden = false; });
    if (expandButton) expandButton.hidden = true;
  });

  document.querySelectorAll('select[data-tis-required-option="size"]').forEach((select) => {
    const section = select.closest('section');
    const primaryButton = section?.querySelector('.product-form__submit');
    const primaryLabel = primaryButton?.querySelector('span');
    if (!primaryButton || !primaryLabel) return;

    const requireSize = () => {
      if (select.value) return;
      primaryButton.disabled = true;
      primaryButton.dataset.tisAwaitingSize = 'true';
      primaryLabel.textContent = 'Add To Cart';
    };

    requireSize();
    select.addEventListener('change', () => {
      if (!select.value) {
        requireSize();
        return;
      }
      delete primaryButton.dataset.tisAwaitingSize;
    });

    // The server-rendered default variant is already current. Dispatching a synthetic
    // change here invokes Dawn gallery and pickup methods that some product layouts
    // intentionally do not provide.
  });

  document.querySelectorAll('[data-tis-product-sticky-cart]').forEach((stickyBar) => {
    const section = document.getElementById(`MainProduct-${stickyBar.dataset.sectionId}`);
    const primaryButton = section?.querySelector('.product-form__submit');
    const stickyButton = stickyBar.querySelector('[data-tis-sticky-submit]');
    const stickyPrice = stickyBar.querySelector('[data-tis-sticky-price]');
    const primaryPriceContainer = section?.querySelector('.tis-product-price');

    if (!primaryButton || !stickyButton) return;

    const synchronize = () => {
      const primaryLabel = primaryButton.querySelector('span')?.textContent.trim() || 'Add To Cart';
      stickyButton.textContent = primaryLabel.replace(/Add To Bag/gi, 'Add To Cart');
      stickyButton.disabled = primaryButton.disabled;
      const primaryPrice = primaryPriceContainer?.querySelector('.price-item--regular, .price-item--sale');
      if (primaryPrice?.textContent.trim()) stickyPrice.textContent = primaryPrice.textContent.trim();
    };

    synchronize();
    new MutationObserver(synchronize).observe(primaryButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
    if (primaryPriceContainer) {
      new MutationObserver(synchronize).observe(primaryPriceContainer, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    let primaryHasPassed = false;
    let footerIsVisible = false;
    const footer = document.querySelector('footer');

    const updateVisibility = () => {
      const visible = primaryHasPassed && !footerIsVisible;
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
      stickyBar.toggleAttribute('inert', !visible);
    };

    new IntersectionObserver(
      ([entry]) => {
        primaryHasPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateVisibility();
      },
      { threshold: 0.05 },
    ).observe(primaryButton);

    if (footer) {
      new IntersectionObserver(
        ([entry]) => {
          footerIsVisible = entry.isIntersecting;
          updateVisibility();
        },
        { threshold: 0 },
      ).observe(footer);
    }

    stickyButton.addEventListener('click', () => primaryButton.click());
  });

  document.querySelectorAll('.tis-product-page .product__info-container.product__column-sticky').forEach((column) => {
    const accordions = column.querySelectorAll('details');

    const fitStickyColumn = () => {
      if (window.matchMedia('(max-width: 989px)').matches) {
        column.style.removeProperty('--tis-product-sticky-top');
        return;
      }

      const preferredTop = 140;
      const viewportBreathingRoom = 28;
      const fittedTop = Math.min(preferredTop, window.innerHeight - column.offsetHeight - viewportBreathingRoom);
      column.style.setProperty('--tis-product-sticky-top', `${Math.round(fittedTop)}px`);
    };

    fitStickyColumn();
    window.addEventListener('resize', fitStickyColumn, { passive: true });
    accordions.forEach((accordion) => accordion.addEventListener('toggle', () => window.requestAnimationFrame(fitStickyColumn)));

    if ('ResizeObserver' in window) {
      new ResizeObserver(fitStickyColumn).observe(column);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const variantId = event?.data?.variant?.id;
      const waitlistHost = sectionId
        ? document.getElementById(`MainProduct-${sectionId}`)?.querySelector('[data-tis-waitlist-host]')
        : null;
      if (!waitlistHost || !variantId) return;

      waitlistHost.dataset.variantId = variantId;
      waitlistHost.dispatchEvent(
        new CustomEvent('tis:waitlist:variant-change', {
          bubbles: true,
          detail: { sectionId, variantId },
        }),
      );
    });
  }
})();

(() => {
  const soldOutLabel = window.variantStrings?.soldOut || 'Sold Out';
  const unavailableLabel = window.variantStrings?.unavailable || 'Unavailable';

  document.querySelectorAll('variant-selects').forEach((picker) => {
    const section = picker.closest('section');
    const productForm = section?.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = productForm?.querySelector('input[name="id"]');
    const addButton = productForm?.querySelector('[name="add"]');
    const addButtonLabel = addButton?.querySelector('span');
    const sizeSelect = picker.querySelector('select[data-tis-required-option="size"]');
    const variantDataElement = picker.querySelector('script[type="application/json"]');

    if (!productForm || !variantInput || !addButton || !addButtonLabel || !variantDataElement) return;

    let variants;
    try {
      variants = JSON.parse(variantDataElement.textContent);
    } catch (error) {
      console.error('Unable to read product variant data.', error);
      return;
    }

    const selectedVariant = () => {
      const selectedOptions = [...picker.querySelectorAll('select')].map((select) => select.value);
      if (selectedOptions.some((value) => !value)) return null;
      return variants.find((variant) => variant.options.every((option, index) => option === selectedOptions[index]));
    };

    const synchronizePurchaseState = () => {
      const variant = selectedVariant();

      if (!variant) {
        addButton.disabled = true;
        addButtonLabel.textContent = sizeSelect && !sizeSelect.value ? 'Add To Cart' : unavailableLabel;
        return null;
      }

      variantInput.value = String(variant.id);
      variantInput.disabled = !variant.available;
      addButton.disabled = !variant.available;
      addButtonLabel.textContent = variant.available
        ? addButton.dataset.availableLabel || window.variantStrings?.addToCart || 'Add To Cart'
        : soldOutLabel;

      return variant;
    };

    picker.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', synchronizePurchaseState);
    });

    productForm.addEventListener(
      'submit',
      (event) => {
        const variant = synchronizePurchaseState();
        if (variant?.available) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      },
      { capture: true },
    );

    synchronizePurchaseState();
  });
})();
